// extracted by mini-css-extract-plugin
var _1 = "container--WkgSFj17";
var _2 = "form--nBQ2vmzG";
var _3 = "message--_dzc95LQ";
var _4 = "messageError--y46MKwZz message--_dzc95LQ";
var _5 = "user--FPhwHjVx";
export { _1 as "container", _2 as "form", _3 as "message", _4 as "messageError", _5 as "user" }
